import { graphql } from 'relay-runtime';

export const createToolUsageRuleMutation = graphql`
    mutation usageControlsMutationsCreateMutation($input: CreateToolUsageRuleInput!) {
        createToolUsageRule(input: $input) {
            id
            toolUsageRuleID
            applyToAllTools
            allowLoggedUsers
            allowNonLoggedUsers
            limitEnabled
            limitPeriodType
            maxOperations
            limitPeriodMinutes
            toolTargets {
                toolType
            }
        }
    }
`;

export const updateToolUsageRuleMutation = graphql`
    mutation usageControlsMutationsUpdateMutation($input: UpdateToolUsageRuleInput!) {
        updateToolUsageRule(input: $input) {
            id
            toolUsageRuleID
            applyToAllTools
            allowLoggedUsers
            allowNonLoggedUsers
            limitEnabled
            limitPeriodType
            maxOperations
            limitPeriodMinutes
            toolTargets {
                toolType
            }
        }
    }
`;

export const deleteToolUsageRuleMutation = graphql`
    mutation usageControlsMutationsDeleteMutation($toolUsageRuleID: Long!) {
        deleteToolUsageRule(toolUsageRuleID: $toolUsageRuleID)
    }
`;
